import React from 'react';

const SmartLink = React.forwardRef(
  (
    {
      children,
      to,
      activeClassName,
      partiallyActive,
      animate = false,
      isExternal = false,
      isJumpLink = false,
      state,
      ...rest
    },
    ref
  ) => {
    /**
     * NOTE: To keep redirects working as expected,
     *`redirects` and `wildcards` should match what
     * we have in `netlify_crossdomain_redirects.txt`.
     */

    /*    const redirects = [
      '/admin/',
      '/admin',
      '/login/',
      '/login',
      '/sso',
      '/embed',
      '/replay',
      '/testdrive',
      '/resetpass',
      '/acceptinvite',
      '/completesignup',
      '/loginsetup',
      '/opt/upgrade/',
      '/opt/upgrade',
      '/sessionLinks/',
      '/sessionLinks',
      '/acceptSessionShareVerifyEmail',
      '/googleStart',
      '/googleFinish',
      '/ui',
      '/rec',
      '/resource',
      '/cspReport',
      '/stripeWebHook',
      '/signup',
    ];

    const wildcards = [
      '/sso/',
      '/embed/',
      '/replay/',
      '/testdrive/',
      '/v/',
      '/ui/',
      '/rec/',
      '/resource/',
      '/api/',
      '/souq/',
      '/signup/',
    ];*/

    // const matchesRedirect = redirects.some((redirect) => to === redirect);
    // const startsWithWildcard = wildcards.some((wildcard) => to?.startsWith(wildcard));

    // Use <a> tags for relative paths that redirect
    //if (1 === 1) {
    //matchesRedirect || startsWithWildcard) {
    /*if (to && animate) {
        return (
          <TransitionLink
            to={to + '/'}
            ref={ref}
            entry={{
              length: 0.5,
              trigger: ({ node, exit }) =>
                swipe({ node, exit, direction: 'left', top: 'exit', entryOffset: 100, triggerName: 'entry' }),
              zIndex: 2,
            }}
            exit={{
              length: 1.2,
              zIndex: 0,
            }}
            {...rest}
          >
            {children}
          </TransitionLink>
        );
      }*/
    if (to) {
      return to.indexOf('#') === 0 || (/^\/(?!\/)/.test(to) && !isExternal) ? (
        <a href={to} {...rest} ref={ref} data-analytics-id={to} data-analytics-component={'link'}>
          {children}
        </a>
      ) : (
        <a
          href={to}
          target="_blank"
          rel="noopener noreferrer"
          {...rest}
          ref={ref}
          data-analytics-id={to}
          data-analytics-component={'link'}
        >
          {children}
        </a>
      );
    }
    return isJumpLink ? (
      <span {...rest} ref={ref} data-analytics-component={'jump-link'}>
        {children}
      </span>
    ) : (
      <a {...rest} ref={ref} data-analytics-component={'link'}>
        {children}
      </a>
    );
    //}

    // Use Gatsby Link for local routes (those that start with '/') and <a> for others
    // return to.indexOf('#') === 0 || (/^\/(?!\/)/.test(to) && !isExternal) ? (
    //   <Location ref={ref}>
    //     {({ location }) => (
    //       <GatsbyLink
    //         to={to}
    //         target="_self"
    //         activeClassName={activeClassName}
    //         partiallyActive={partiallyActive}
    //         {...rest}
    //         state={{ prevPath: location.pathname, ...state }}
    //       >
    //         {children}
    //       </GatsbyLink>
    //     )}
    //   </Location>
    // ) : (
    //   <a href={to} target="_blank" rel="noopener noreferrer" {...rest} ref={ref}>
    //     {children}
    //   </a>
    // );
  }
);

export default SmartLink;
